import {
  chatState,
  toggleChat,
  setToken,
  quitChat,
  setType,
} from "./chatState";
import { InjectionKey, watchEffect } from "vue";
import { useIframeHandler } from "./iframe-handler";
import { ChatType } from "./chatService";

export interface ChatControls {
  openChat: (type: ChatType) => void;
  closeChat: () => void;
  updateToken: (newToken: string) => void;
  updateChatRoomId: (newRoomId: string) => void;
  handleLogin: () => void;
  getGlobalUnreadCount: () => number;
  chatState: typeof chatState;
}

export function useChatControls(): ChatControls {
  const { attemptLogin, updateChatRoom } = useIframeHandler();

  watchEffect(() => {
    if (window.electronAPI) {
      const count = chatState.globalUnreadCount;
      window.electronAPI.updateUnreadCount(count);
      console.log("updateUnreadCount", count);
    }
  });

  function openChat(type: ChatType = "home") {
    setType(type);
    toggleChat(true);
  }

  function closeChat() {
    toggleChat(false);
  }

  function updateChatToken(newToken: string) {
    quitChat();
    setToken(newToken);
    // 触发登录尝试
    attemptLogin();
  }
  function updateChatRoomId(newRoomId: string) {
    setType("user");
    updateChatRoom(newRoomId);
  }
  function handleLogin() {
    attemptLogin();
  }
  function getGlobalUnreadCount() {
    return chatState.globalUnreadCount;
  }
  return {
    openChat,
    closeChat,
    updateToken: updateChatToken,
    updateChatRoomId: updateChatRoomId,
    handleLogin,
    getGlobalUnreadCount,
    chatState,
  };
}

export const chatControlsKey = Symbol(
  "chatControls"
) as InjectionKey<ChatControls>;
